import React from "react";

const BillingHelptext = () => (
  <div className="helptext">
    <p>Changing the billing details does not affect any other accounts that you may have. Likewise, if you would like to use a different credit card for a subscription, then you need to create an additional account.</p>
  </div>
)

export default BillingHelptext;